import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ISbStoryData } from '@storyblok/js';
import { PricingService } from '../../../services/pricing.service';
import { StoryblokService } from '../../../services/storyblok.service';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { ProductFeatureTooltipComponent } from '../../../shared/components/product-feature-tooltip/product-feature-tooltip.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TooltipContentComponent } from '../../../shared/components/tooltip-content/tooltip-content.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { StoryblokCdnPipe } from '../../../storyblok/pipes/storyblok-cdn.pipe';
import { StoryblokRichTextPipe } from '../../../storyblok/storyblok-rich-text.pipe';
import { Product } from '../../../types/product.type';

@Component({
  selector: 'app-checkout-sidebar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SvgComponent,
    DatePipe,
    StoryblokRichTextPipe,
    TooltipDirective,
    ContextMenuComponent,
    TooltipContentComponent,
    StoryblokCdnPipe,
    ProductFeatureTooltipComponent,
  ],
  templateUrl: './checkout-sidebar.component.html',
  styleUrl: './checkout-sidebar.component.scss',
})
export class CheckoutSidebarComponent {
  private pricingService = inject(PricingService);
  private storyblokService = inject(StoryblokService);
  product = input.required<Product>();
  startTrialMode = input.required<boolean>();
  trialLengthDays = signal(this.pricingService.getTrialLengthDays());
  trialEndDate = computed(() => new Date(Date.now() + this.trialLengthDays() * 24 * 60 * 60 * 1000));
  allPricingBoxContent = toSignal(this.storyblokService.getStories({ content_type: 'PricingBox' }));
  pricingBoxContent = computed(() => {
    const allPricingBoxContent = this.allPricingBoxContent();
    const product = this.product();
    if (!allPricingBoxContent || !product) return;

    return allPricingBoxContent.find((data: ISbStoryData) => data.content.product === product.storyblokLinkId);
  });
}
